import { createSelector } from 'reselect';

import {
  filters
} from '@Containers/ResultsFilters/ResultsFiltersComponents/ListOfFilters/ListOfFiltersSelectors';


export const filterMap = {
  [1]: handleGroupFilter,
  [2]: handleGroupFilter,
  [4]: handleCheckboxFilter,
  [5]: handeStructureFilter,
};

export function handleGroupFilter (filter) {
  const groups = filter.get('groups');
  const userInputValue = filter.get('userInputValue');

  if (!groups.count()) {
    return false;
  }

  if (userInputValue) {
    return true;
  }

  return groups.some((item) => {
    return item.get('selected');
  });
}

export function handleCheckboxFilter (filter) {
  return filter.get('selected');
}

export function handeStructureFilter (filter) {
  return filter.get('selected');
}

export const disableButtons = createSelector(
  [filters],
  (filters) => {
    if (!filters) {
      return true;
    }
    const result = filters
      .some((filter) => {
        const type = filter.get('type');
        const handler = filterMap[type];
        if (!handler) {
          return false;
        }
        return handler(filter);
      });

    return !result;
  }
);
